/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Rounds_Table_CountInputs */



/**
* | output |
* | --- |
* | "{count} tables" |
*
* @param {Rounds_Table_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_table_count = /** @type {((inputs: Rounds_Table_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Table_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} tables`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} mesas`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} mesas`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} tavoli`)
	return /** @type {LocalizedString} */ (`${i?.count} tables`)
});